import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {AuthProvider} from "./components/AuthService/AuthProvider";
import Login from "./components/Login/Login";
import CryptoExchanger from "./components/CryptoExchanger/CryptoExchanger";
import About from "./components/FooterPages/About";
import AMLPolicy from "./components/FooterPages/Aml";
import PrivacyPolicy from "./components/FooterPages/Privacy";
import TermsOfUse from "./components/FooterPages/Terms";
import Orders from "./components/Orders/Orders";
import "./App.css"
import PrivateRoute from "./components/AuthService/PrivateRoute";

function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Navigate to="/crypto-exchanger"/>}/>
                    <Route path="/crypto-exchanger" element={<CryptoExchanger/>}/>
                    <Route path="/fast-exchange" element={<CryptoExchanger/>}/>
		    <Route path="/company" element={<About/>}/>
                    <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                    <Route path="/aml-policy" element={<AMLPolicy/>}/>
                    <Route path="/terms-of-use" element={<TermsOfUse/>}/>
                    <Route path="/exchange-result" element={<CryptoExchanger/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route
                        path="/orders"
                        element={
                            <PrivateRoute adminOnly={true}>
                                <Orders/>
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </AuthProvider>
        </Router>
    );
}

export default App;
